import React, { useState } from "react";
import Select from "react-select";

function Temp() {
  const [value, setValue] = useState(null);

  const handleSelectChange = (newValue) => {
    if (newValue === null) {
      setValue(null);
    } else {
      setValue(newValue);
    }
  };

  console.log(value);

  return (
    <div className="">
      <div className="container">
        <div className="max-w-[600px] mx-auto">
          <Select
            value={value}
            onChange={handleSelectChange}
            isClearable
            options={[
              { value: "option1", label: "Option 1" },
              { value: "option2", label: "Option 2" },
              { value: "option3", label: "Option 3" },
            ]}
          />
        </div>
      </div>
    </div>
  );
}

export default Temp;
